
export default {
  getPdfForSchedule(programId) {
    return env.API.post('/pdf/schedule', {programId}, {responseType: 'blob'});
  },
  getPdfForBlend(blendName, containerCapacity, programId) {
    return env.API.post('/pdf/blend', {blendName, containerCapacity, programId}, {responseType: 'blob'});
  },
  getPdfForAdjust(programId) {
    return env.API.post('/pdf/adjust', {programId}, {responseType: 'blob'});
  },
  getPdfForBaseDressing(programId) {
    return env.API.post('/pdf/base-dressing', {programId}, {responseType: 'blob'});
  },
  getPdfForFertigation(programId) {
    return env.API.post('/pdf/fertigation', {programId}, {responseType: 'blob'});
  },

  getGlobalPdf(programId, pages) {
    return env.API.post('/pdf/global', { programId, pages }, { responseType: 'blob' });
  },

  getAdminPdf(programId) {
    return env.API.get(`/pdf/global/${programId}`, { responseType: 'blob' });
  },

  getPdfById(id) {
    return env.API.post('/pdf/getPdfById', {id}, {responseType: 'blob'});
  },
  getExcel(id) {
    return env.API.post('/excel/global', {programId: id}, {responseType: 'blob'});
  },
}
